import { render, staticRenderFns } from "./Adress.html?vue&type=template&id=0df715dc&scoped=true&"
import script from "./Adress.ts?vue&type=script&lang=ts&"
export * from "./Adress.ts?vue&type=script&lang=ts&"
import style0 from "./Adress.css?vue&type=style&index=0&id=0df715dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df715dc",
  null
  
)

export default component.exports